const SET_STORE = "jola/store/SET_STORE";

const allTypes = { SET_STORE };

export default allTypes;
